<script setup lang="ts">
import { assetLink } from "@/common/util"
import type { BlogPost } from "@/model/backend/blog-post"
import { $formatDate, useHttpGet } from "@/vf"
import { presetImages } from "@/common/assets/preset-images/preset-images"
import { useShopAppConfig } from "@/shop/composables"
import { useAuthentication } from "@/shop/composables/useAuthentication"
/*─────────────────────────────────────┐
│   props                              │
└─────────────────────────────────────*/
const props = defineProps<{
    id: string
}>()

const { login } = useAuthentication()
const { data: post } = await useHttpGet<BlogPost>(`/blog/${props.id}`)
const { appConfig, refreshAppConfig } = useShopAppConfig()
refreshAppConfig()
</script>

<template>
    <div class="container">
        <div class="breadcrumb">
            <RouterLink class="breadcrumb-item" :to="{ name: 'home' }">Home</RouterLink>
            <RouterLink class="breadcrumb-item" :to="{ name: 'blog' }">Neuigkeiten</RouterLink>
            <div class="breadcrumb-item">{{ post!.title }}</div>
        </div>
    </div>
    <div v-if="post!.onlyVisibleForLoggedInUsers && !appConfig.user" class="container my-auto">
        <div class="row align-items-center flex-row-reverse flex-md-row">
            <div class="col-md-4">
                <div style="max-width: 50vw; margin: 0 auto" aria-hidden="true">
                    <img :src="presetImages[2]" width="1026" height="1365" alt="" class="img-fluid" />
                </div>
            </div>
            <div class="col-md-8 mt-5 mt-md-0 px-4 px-md-0">
                <h1>Jetzt einloggen und mehr entdecken</h1>

                <p aria-label="Einloggen erforderlich">
                    Dieser Artikel steht exklusiv der CANN24-Community zur Verfügung. Bitte
                    <a href="#" @click="login">logge dich</a>
                    erst ein, um weiterzulesen. Wenn du noch nicht Mitglied der CANN24-Community bist, kannst du dich
                    <RouterLink :to="{ name: 'registration' }">hier registrieren</RouterLink>
                    <span>.</span>
                </p>
            </div>
        </div>
    </div>
    <div v-else class="container">
        <div class="blog-post-image">
            <img
                style="max-height: 500px"
                class="img-fluid mx-auto d-block"
                :src="post?.presetImageIndex === undefined ? assetLink('/uploads/media/' + post!.imageName) : presetImages[post.presetImageIndex]"
                alt=""
            />
        </div>
        <div v-if="post!.onlyVisibleForLoggedInUsers" class="bg-primary px-2 py-1 my-2 text-center">
            <h2 class="text-white m-0">&bullet; Community Exklusiv &bullet;</h2>
        </div>
        <!-- @formatter:off -->
        <h2>{{ $formatDate(post!.date!, "dd. LLLL yyyy") }} / {{ post!.categoryName }}</h2>
        <!-- @formatter:on -->
        <h1>{{ post!.title }}</h1>

        <p class="pre-line">
            {{ post!.introText }}
        </p>

        <p v-html="post!.text"></p>
    </div>
</template>
